import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useCapturedParams } from "../../../lib/cleanUrl";
import { AdminAppShell } from "../../../design-system/shells/AdminAppShell";
import { useAuth } from "../../../lib/auth";
import { api } from "../../../lib/api";
import { errMsg } from "../../../lib/portfolio";

export default function PortfolioInvite() {
  const { user } = useAuth();
  const { token } = useCapturedParams();
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const once = useRef(false);
  useEffect(() => {
    if (once.current) return;
    once.current = true;
    api.post("/admin/portfolio/invites/redeem", { token: token || "" })
      .then((r) => navigate(`/admin/portfolio/${r.data.project_id}/review`, { replace: true }))
      .catch((e) => setError(errMsg(e, "This invite link could not be used.")));
  }, [token, navigate]);
  return (
    <AdminAppShell activeNav="portfolio" title="Reviewer invite" user={user}
      breadcrumbs={[{ label: "Portfolio Manager", to: "/admin/portfolio" }, { label: "Invite", to: null }]}>
      {error ? (
        <div className="space-y-2" data-testid="portfolio-invite-error">
          <p className="text-sm font-nav text-[#991B1B]" role="alert">{error}</p>
          <Link to="/admin/portfolio" className="text-sm font-nav underline text-erf-dark">Go to Portfolio Manager</Link>
        </div>
      ) : (
        <p className="text-sm font-nav text-erf-dark" data-testid="portfolio-invite-redeeming">Opening your review…</p>
      )}
    </AdminAppShell>
  );
}
